export default "__VITE_ASSET__RKjeeeRZ__"